import { useEffect, useState } from "react";
import Api from "../../Api";
import { useNavigate, useParams } from "react-router-dom";
import QuoteForm from "../../parts/quote/Form";
import ClientBar from "../../parts/ClientBar";
import { Client, Quote, QuoteItem, QuoteAsForm, UIValue } from "../../types";
import DiscreetMessage from "../../parts/DiscreetMessage";

const MyQuotesCreate2 = () => {
  const navigate = useNavigate();
  const { clientUuid } = useParams();
  const [error, setError] = useState(false);
  const [client, setClient] = useState<Client | null>(null);

  const [quote, setQuote] = useState<QuoteAsForm>({
    uuid: "",
    clientUuid: "",
    number: 0,
    creationDate: new Date(),
    isApproved: false,
    approvalDate: null,
    isAuthorized: false,
    authorizationDate: null,
    externalHash: "",
    feeMonitoring: "R$ 0,00",
    feeInstall: "R$ 0,00",
    feeReview: "R$ 0,00",
    itemsSold: [],
    itemsRented: [],
    discountSale: "0,00",
    discountRent: "0,00",
    maxInstallments: "3",
    note: "",
    imported: false,
    sends: [],
    tasks: {
      signature: false,
      order: false,
      equipment: false,
      install: false,
      billing: false,
      commission: false,
    },
    authorizedByClient: null,
    isCancelled: false,
    cancellationDate: null,
    notes: [],
    push: [],
    rentContractInfo: null,
    monitoringContractInfo: null,
  });

  useEffect(() => {
    Api.myQuotesGetClient(clientUuid!).then(setClient);
  }, [clientUuid]);

  if (!client) {
    return <DiscreetMessage text="Carregando ..." />;
  }

  const updateQuote = (key: string) => (value: UIValue | QuoteItem[]) => {
    setQuote((quote) => ({ ...quote, [key]: value }));
  };

  const save = async (payload: Quote) => {
    setError(false);
    const result = await Api.myQuotesCreate(client.uuid, payload);
    result.success ? navigate("/meus-orcamentos") : setError(true);
  };

  return (
    <div>
      <ClientBar
        action="Criando um novo orçamento para"
        client={client.name}
        url={"/meus-orcamentos/criar"}
      />

      <QuoteForm
        quote={quote}
        onChange={updateQuote}
        onSave={save}
        buttonLabel="Criar"
        error={error}
      />
    </div>
  );
};

export default MyQuotesCreate2;
